import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import React from 'react';

import { UploadFileExtension } from 'packages/manualDataTapeUploads/ui/UploadDataTapeDropzone';
import { UploadDataTapeForm } from 'packages/manualDataTapeUploads/ui/UploadDataTapeForm';

export const UploadModal = ({
  modalHeaderText,
  handleFile,
  allowedExtensions,
  isOpen,
  onClose,
  children,
}: {
  isOpen: boolean;
  onClose: () => void;
  modalHeaderText?: string;
  handleFile: (file: File) => Promise<void>;
  allowedExtensions: UploadFileExtension[];
  children?: React.ReactNode;
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent padding="20px" width="auto" minW="550px">
        <ModalHeader>{modalHeaderText ?? 'Upload Tape'}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {children}
          <UploadDataTapeForm
            allowedExtensions={allowedExtensions}
            onClose={onClose}
            handleFile={handleFile}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
